export default "__VITE_ASSET__BGqunV5J__"